export default function CACustomerServicesDirective() {
  return {
    template: require('./customer-services.directive.html'),
    scope: {
      customer: '=',
      services: '=',
    },
    controller: 'CACustomerServicesDirectiveController',
    controllerAs: 'customerServicesVM',
    bindToController: true,
    replace: true,
  };
}
